
import {defineComponent, ref, reactive, computed, onMounted, watch} from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import AddAsoProjectModal from "@/components/modals/forms/AddAsoProjectModal.vue";
import UpdateAsoReportModal from "@/components/modals/forms/UpdateAsoReportModal.vue";
import DeleteModal from "@/components/modals/forms/DeleteModal.vue";
import { MenuComponent } from "@/assets/ts/components";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import {AsoProject, Client} from "@/store/modules/ApiModule";
import UpdateUaReportModal from "@/components/modals/forms/UpdateUaReportModal.vue";


export default defineComponent({
  name: "aso-projects-listing",
  components: {
    Datatable,
    AddAsoProjectModal,
    UpdateAsoReportModal,
    DeleteModal
  },
  setup() {
    const tableHeader = ref([
      {
        name: "Name",
        key: "name",
        sortable: true,
      },
      {
        name: "Client",
        key: "client",
        sortable: true,
      },
      {
        name: "OS",
        key: "os",
        sortable: true,
      },
      {
        name: "Update",
        key: "update",
      },
      {
        name: "Actions",
        key: "actions",
      },
    ]);

    const store = useStore();
    let myAsoProjects = ref<Array<AsoProject>>([]);
    let selectedItem = reactive({} as AsoProject);

    let myData = computed(() => {
      return store.state.api.asoProjects;
    });

    const setSelectedItem = (item) => {
      if(item == null){
        Object.assign(selectedItem, {
          id: 0, name: "", os: "", client: {} as Client
        });
      }
      else {
        Object.assign(selectedItem, item);
      }
    }

    onMounted(() => {
      MenuComponent.reinitialization();
      store.dispatch(Actions.LOAD_ASOPROJECTS);
    });

    watch(myData, (newValue, oldValue) => {
      myAsoProjects.value.splice(0,myAsoProjects.value.length)
      newValue.forEach(function (value) {
        myAsoProjects.value.push(value);
      });
    });

    const search = ref<string>("");
    const searchItems = () => {
      /*tableData.value.splice(0, tableData.value.length, ...initClients.value);
      if (search.value !== "") {
        let results: Array<Client> = [];
        for (let j = 0; j < tableData.value.length; j++) {
          if (searchingFunc(tableData.value[j], search.value)) {
            results.push(tableData.value[j]);
          }
        }
        tableData.value.splice(0, tableData.value.length, ...results);
      }*/
    };

    const searchingFunc = (obj, value): boolean => {
      for (let key in obj) {
        if (!Number.isInteger(obj[key]) && !(typeof obj[key] === "object")) {
          if (obj[key].indexOf(value) != -1) {
            return true;
          }
        }
      }
      return false;
    };

    return {
      myData,
      myAsoProjects,
      selectedItem,
      setSelectedItem,
      tableHeader,
      search,
      searchItems
    };
  },
});
